import { render, staticRenderFns } from "./RecentWorkItem.vue?vue&type=template&id=6df0ceab&scoped=true&"
import script from "./RecentWorkItem.vue?vue&type=script&lang=ts&"
export * from "./RecentWorkItem.vue?vue&type=script&lang=ts&"
import style0 from "./RecentWorkItem.vue?vue&type=style&index=0&id=6df0ceab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0ceab",
  null
  
)

export default component.exports